// extracted by mini-css-extract-plugin
module.exports = {"0":"style_0__2nPfx","1":"style_1__1zJU7","2":"style_2__2ZycE","3":"style_3__2pBgH","issue-message":"style_issue-message__3fevk","icon":"style_icon__29Kba"};